import { render, staticRenderFns } from "./dialogResetPassword.vue?vue&type=template&id=48849a4a&"
import script from "./dialogResetPassword.vue?vue&type=script&lang=js&"
export * from "./dialogResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./dialogResetPassword.vue?vue&type=style&index=0&id=48849a4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports